import React from 'react'
import styles from './NotDoneYetDialog.scss'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'

export const NOT_DONE_YET_DIALOG = 'NOT_DONE_DIALOG'

export const NotDoneYetDialog = ({onRequestClose}) => (
  <ModalOverlay
    title='Feature Not Done Yet'
    maxWidth='800px'
    onRequestClose={onRequestClose}>
    <div className={styles.NotDoneYetDialog}>
      <video autoPlay loop poster='' muted className={styles.video}>
        <source src='https://fat.gfycat.com/SomberAlarmingGuineafowl.webm' type='video/webm' />
      </video>
    </div>
  </ModalOverlay>
)
